export interface Musica {
  id: string;
  albumId: string;
  artistaId: string;
  artistaNome: string;
  albumTitulo: string;
  titulo: string;
  duracao: string;
  preco: number;
  previewDisponivel: boolean;
  paginas: number;
  bpm: number;
  tomOriginal: string;
  versao: string;
  anoLancamento: number;
  tonsDisponiveis: string[];
}

export const TONS_DISPONIVEIS = ["A", "Ab", "B", "Bb", "C", "Db", "D", "Eb", "E", "F", "F#", "G"];

export const musicas: Musica[] = [
  // Fernandinho - Galileu
  {
    id: "galileu-1",
    albumId: "galileu",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Galileu",
    titulo: "Galileu",
    duracao: "5:42",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "galileu-2",
    albumId: "galileu",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Galileu",
    titulo: "Yahweh",
    duracao: "4:38",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 68,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "galileu-3",
    albumId: "galileu",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Galileu",
    titulo: "A Alegria do Senhor",
    duracao: "3:55",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 128,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "galileu-4",
    albumId: "galileu",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Galileu",
    titulo: "Faz Chover",
    duracao: "6:12",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 64,
    tomOriginal: "A",
    versao: "Estúdio",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "galileu-5",
    albumId: "galileu",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Galileu",
    titulo: "Todavia Me Alegrarei",
    duracao: "5:05",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 76,
    tomOriginal: "C",
    versao: "Estúdio",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Fernandinho - Uma Nova História
  {
    id: "nova-1",
    albumId: "uma-nova-historia",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Uma Nova História",
    titulo: "Uma Nova História",
    duracao: "5:28",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 70,
    tomOriginal: "Bb",
    versao: "Estúdio",
    anoLancamento: 2015,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "nova-2",
    albumId: "uma-nova-historia",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Uma Nova História",
    titulo: "Nada Além de Ti",
    duracao: "4:45",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 74,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2015,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "nova-3",
    albumId: "uma-nova-historia",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    albumTitulo: "Uma Nova História",
    titulo: "Só Quero Ver Você",
    duracao: "5:10",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 82,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2015,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // André Valadão - Clássicos
  {
    id: "classicos-1",
    albumId: "classicos",
    artistaId: "andre-valadao",
    artistaNome: "André Valadão",
    albumTitulo: "Clássicos",
    titulo: "Mãos ao Ar",
    duracao: "4:22",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 120,
    tomOriginal: "E",
    versao: "Ao Vivo",
    anoLancamento: 2010,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "classicos-2",
    albumId: "classicos",
    artistaId: "andre-valadao",
    artistaNome: "André Valadão",
    albumTitulo: "Clássicos",
    titulo: "Sonda-me",
    duracao: "5:33",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 66,
    tomOriginal: "A",
    versao: "Ao Vivo",
    anoLancamento: 2010,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "classicos-3",
    albumId: "classicos",
    artistaId: "andre-valadao",
    artistaNome: "André Valadão",
    albumTitulo: "Clássicos",
    titulo: "Vinho Novo",
    duracao: "4:18",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 72,
    tomOriginal: "G",
    versao: "Ao Vivo",
    anoLancamento: 2010,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Ana Paula Valadão - Diante do Trono
  {
    id: "dt1-1",
    albumId: "dt-1",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    albumTitulo: "Diante do Trono",
    titulo: "Quero Te Conhecer",
    duracao: "6:05",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 68,
    tomOriginal: "D",
    versao: "Ao Vivo",
    anoLancamento: 1998,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "dt1-2",
    albumId: "dt-1",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    albumTitulo: "Diante do Trono",
    titulo: "Aclame ao Senhor",
    duracao: "4:50",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 126,
    tomOriginal: "G",
    versao: "Ao Vivo",
    anoLancamento: 1998,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "dt1-3",
    albumId: "dt-1",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    albumTitulo: "Diante do Trono",
    titulo: "Manancial",
    duracao: "5:22",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 74,
    tomOriginal: "C",
    versao: "Ao Vivo",
    anoLancamento: 1998,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Ana Paula Valadão - Exaltado
  {
    id: "exaltado-1",
    albumId: "dt-exaltado",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    albumTitulo: "Exaltado",
    titulo: "Exaltado",
    duracao: "6:15",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 5,
    bpm: 70,
    tomOriginal: "A",
    versao: "Ao Vivo",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "exaltado-2",
    albumId: "dt-exaltado",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    albumTitulo: "Exaltado",
    titulo: "Nos Braços do Pai",
    duracao: "5:40",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "F",
    versao: "Ao Vivo",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Aline Barros - Voz do Milênio
  {
    id: "milenio-1",
    albumId: "voz-do-milenio",
    artistaId: "aline-barros",
    artistaNome: "Aline Barros",
    albumTitulo: "Voz do Milênio",
    titulo: "Ressuscita-me",
    duracao: "4:35",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 68,
    tomOriginal: "Bb",
    versao: "Estúdio",
    anoLancamento: 2000,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "milenio-2",
    albumId: "voz-do-milenio",
    artistaId: "aline-barros",
    artistaNome: "Aline Barros",
    albumTitulo: "Voz do Milênio",
    titulo: "Consagrado",
    duracao: "5:12",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 76,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 2000,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Eli Soares - Casa de Deus
  {
    id: "casa-1",
    albumId: "casa-de-deus",
    artistaId: "eli-soares",
    artistaNome: "Eli Soares",
    albumTitulo: "Casa de Deus",
    titulo: "Casa de Deus",
    duracao: "5:05",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "C",
    versao: "Estúdio",
    anoLancamento: 2017,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "casa-2",
    albumId: "casa-de-deus",
    artistaId: "eli-soares",
    artistaNome: "Eli Soares",
    albumTitulo: "Casa de Deus",
    titulo: "Minha Herança",
    duracao: "4:48",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 70,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2017,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Gabriela Rocha - Lugar Secreto
  {
    id: "lugar-1",
    albumId: "lugar-secreto",
    artistaId: "gabriela-rocha",
    artistaNome: "Gabriela Rocha",
    albumTitulo: "Lugar Secreto",
    titulo: "Lugar Secreto",
    duracao: "5:52",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 66,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2018,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "lugar-2",
    albumId: "lugar-secreto",
    artistaId: "gabriela-rocha",
    artistaNome: "Gabriela Rocha",
    albumTitulo: "Lugar Secreto",
    titulo: "Criador",
    duracao: "4:30",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 74,
    tomOriginal: "A",
    versao: "Estúdio",
    anoLancamento: 2018,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Kleber Lucas - Deus Cuida de Mim
  {
    id: "cuida-1",
    albumId: "deus-cuida",
    artistaId: "kleber-lucas",
    artistaNome: "Kleber Lucas",
    albumTitulo: "Deus Cuida de Mim",
    titulo: "Deus Cuida de Mim",
    duracao: "5:18",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "F",
    versao: "Estúdio",
    anoLancamento: 2004,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "cuida-2",
    albumId: "deus-cuida",
    artistaId: "kleber-lucas",
    artistaNome: "Kleber Lucas",
    albumTitulo: "Deus Cuida de Mim",
    titulo: "Aos Pés da Cruz",
    duracao: "6:05",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 5,
    bpm: 68,
    tomOriginal: "Bb",
    versao: "Estúdio",
    anoLancamento: 2004,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Davi Sacer - Confiar
  {
    id: "confiar-1",
    albumId: "confiar",
    artistaId: "davi-sacer",
    artistaNome: "Davi Sacer",
    albumTitulo: "Confiar",
    titulo: "Deus Não Falhará",
    duracao: "5:25",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 70,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 2012,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "confiar-2",
    albumId: "confiar",
    artistaId: "davi-sacer",
    artistaNome: "Davi Sacer",
    albumTitulo: "Confiar",
    titulo: "Confiar",
    duracao: "4:55",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 74,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2012,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Anderson Freire - Raridade
  {
    id: "raridade-1",
    albumId: "raridade",
    artistaId: "anderson-freire",
    artistaNome: "Anderson Freire",
    albumTitulo: "Raridade",
    titulo: "Raridade",
    duracao: "5:10",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "C",
    versao: "Estúdio",
    anoLancamento: 2013,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "raridade-2",
    albumId: "raridade",
    artistaId: "anderson-freire",
    artistaNome: "Anderson Freire",
    albumTitulo: "Raridade",
    titulo: "Não Há Nada Igual",
    duracao: "4:40",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 76,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2013,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Preto no Branco
  {
    id: "pnb-1-song",
    albumId: "pnb-1",
    artistaId: "preto-no-branco",
    artistaNome: "Preto no Branco",
    albumTitulo: "Preto no Branco",
    titulo: "Ninguém Explica Deus",
    duracao: "4:55",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 130,
    tomOriginal: "F",
    versao: "Estúdio",
    anoLancamento: 2016,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "pnb-2-song",
    albumId: "pnb-1",
    artistaId: "preto-no-branco",
    artistaNome: "Preto no Branco",
    albumTitulo: "Preto no Branco",
    titulo: "Livre Sou",
    duracao: "5:20",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 126,
    tomOriginal: "Bb",
    versao: "Estúdio",
    anoLancamento: 2016,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Rosa de Saron - Depois do Inverno
  {
    id: "inverno-1",
    albumId: "depois-do-inverno",
    artistaId: "rosa-de-saron",
    artistaNome: "Rosa de Saron",
    albumTitulo: "Depois do Inverno",
    titulo: "Depois do Inverno",
    duracao: "4:45",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 82,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 2005,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "inverno-2",
    albumId: "depois-do-inverno",
    artistaId: "rosa-de-saron",
    artistaNome: "Rosa de Saron",
    albumTitulo: "Depois do Inverno",
    titulo: "O Sol da Meia-Noite",
    duracao: "5:30",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 5,
    bpm: 78,
    tomOriginal: "A",
    versao: "Estúdio",
    anoLancamento: 2005,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Oficina G3 - Humanos
  {
    id: "humanos-1",
    albumId: "humanos",
    artistaId: "oficina-g3",
    artistaNome: "Oficina G3",
    albumTitulo: "Humanos",
    titulo: "Humanos",
    duracao: "4:20",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 140,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 1998,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "humanos-2",
    albumId: "humanos",
    artistaId: "oficina-g3",
    artistaNome: "Oficina G3",
    albumTitulo: "Humanos",
    titulo: "De Olhos Fechados",
    duracao: "5:15",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 5,
    bpm: 72,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 1998,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Kemuel
  {
    id: "kemuel-1",
    albumId: "kemuel-album",
    artistaId: "kemuel",
    artistaNome: "Kemuel",
    albumTitulo: "Kemuel",
    titulo: "Santo Pra Sempre",
    duracao: "5:30",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 74,
    tomOriginal: "Bb",
    versao: "Estúdio",
    anoLancamento: 2015,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "kemuel-2",
    albumId: "kemuel-album",
    artistaId: "kemuel",
    artistaNome: "Kemuel",
    albumTitulo: "Kemuel",
    titulo: "Faz Chover",
    duracao: "6:10",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 5,
    bpm: 64,
    tomOriginal: "A",
    versao: "Estúdio",
    anoLancamento: 2015,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Paulo Cesar Baruk
  {
    id: "baruk-1",
    albumId: "baruk-album",
    artistaId: "paulo-cesar-baruk",
    artistaNome: "Paulo Cesar Baruk",
    albumTitulo: "Baruk",
    titulo: "Baruk",
    duracao: "5:45",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 68,
    tomOriginal: "C",
    versao: "Estúdio",
    anoLancamento: 2012,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "baruk-2",
    albumId: "baruk-album",
    artistaId: "paulo-cesar-baruk",
    artistaNome: "Paulo Cesar Baruk",
    albumTitulo: "Baruk",
    titulo: "A Ti a Honra",
    duracao: "5:20",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2012,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Leandro Borges
  {
    id: "borges-1",
    albumId: "identidade",
    artistaId: "leandro-borges",
    artistaNome: "Leandro Borges",
    albumTitulo: "Identidade",
    titulo: "Identidade",
    duracao: "5:15",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 70,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2019,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "borges-2",
    albumId: "identidade",
    artistaId: "leandro-borges",
    artistaNome: "Leandro Borges",
    albumTitulo: "Identidade",
    titulo: "Primeiro Amor",
    duracao: "4:50",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 76,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 2019,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Vinicius Zulato
  {
    id: "zulato-1",
    albumId: "filho-prodigo",
    artistaId: "vinicius-zulato",
    artistaNome: "Vinicius Zulato",
    albumTitulo: "Filho Pródigo",
    titulo: "Filho Pródigo",
    duracao: "5:25",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2022,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "zulato-2",
    albumId: "filho-prodigo",
    artistaId: "vinicius-zulato",
    artistaNome: "Vinicius Zulato",
    albumTitulo: "Filho Pródigo",
    titulo: "Pra Sempre",
    duracao: "4:40",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 74,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2022,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Anderson Capote
  {
    id: "capote-1",
    albumId: "deixa-arder",
    artistaId: "anderson-capote",
    artistaNome: "Anderson Capote",
    albumTitulo: "Deixa Arder",
    titulo: "Deixa Arder",
    duracao: "5:10",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 78,
    tomOriginal: "F",
    versao: "Estúdio",
    anoLancamento: 2021,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "capote-2",
    albumId: "deixa-arder",
    artistaId: "anderson-capote",
    artistaNome: "Anderson Capote",
    albumTitulo: "Deixa Arder",
    titulo: "Consumido",
    duracao: "4:55",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 82,
    tomOriginal: "A",
    versao: "Estúdio",
    anoLancamento: 2021,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Adhemar de Campos
  {
    id: "adhemar-1",
    albumId: "consagrado",
    artistaId: "adhemar-de-campos",
    artistaNome: "Adhemar de Campos",
    albumTitulo: "Consagrado",
    titulo: "Consagrado",
    duracao: "5:30",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 68,
    tomOriginal: "Bb",
    versao: "Estúdio",
    anoLancamento: 1990,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "adhemar-2",
    albumId: "consagrado",
    artistaId: "adhemar-de-campos",
    artistaNome: "Adhemar de Campos",
    albumTitulo: "Consagrado",
    titulo: "Glória a Deus",
    duracao: "4:45",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 120,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 1990,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Heloisa Rosa
  {
    id: "heloisa-1",
    albumId: "heloisa-rosa",
    artistaId: "heloisa-rosa",
    artistaNome: "Heloisa Rosa",
    albumTitulo: "Heloisa Rosa",
    titulo: "Heloisa Rosa",
    duracao: "5:20",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 70,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2019,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "heloisa-2",
    albumId: "heloisa-rosa",
    artistaId: "heloisa-rosa",
    artistaNome: "Heloisa Rosa",
    albumTitulo: "Heloisa Rosa",
    titulo: "Maranata",
    duracao: "5:10",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 74,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2019,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Comunidade de Nilópolis
  {
    id: "nilopolis-1",
    albumId: "o-deus-que-faz",
    artistaId: "comunidade-de-nilopolis",
    artistaNome: "Comunidade de Nilópolis",
    albumTitulo: "O Deus que Faz",
    titulo: "O Deus que Faz",
    duracao: "5:40",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 76,
    tomOriginal: "C",
    versao: "Ao Vivo",
    anoLancamento: 2015,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "nilopolis-2",
    albumId: "o-deus-que-faz",
    artistaId: "comunidade-de-nilopolis",
    artistaNome: "Comunidade de Nilópolis",
    albumTitulo: "O Deus que Faz",
    titulo: "Milagres",
    duracao: "5:15",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "F",
    versao: "Ao Vivo",
    anoLancamento: 2015,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Quatro por Um
  {
    id: "quatro-1",
    albumId: "quatro-por-um",
    artistaId: "quatro-por-um",
    artistaNome: "Quatro por Um",
    albumTitulo: "Quatro por Um",
    titulo: "Quatro por Um",
    duracao: "4:55",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 132,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "quatro-2",
    albumId: "quatro-por-um",
    artistaId: "quatro-por-um",
    artistaNome: "Quatro por Um",
    albumTitulo: "Quatro por Um",
    titulo: "Vida Nova",
    duracao: "5:05",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 128,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 2003,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - David Quinlan
  {
    id: "quinlan-1",
    albumId: "eu-e-minha-casa",
    artistaId: "david-quinlan",
    artistaNome: "David Quinlan",
    albumTitulo: "Eu e a Minha Casa",
    titulo: "Eu e a Minha Casa",
    duracao: "5:35",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 68,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2005,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "quinlan-2",
    albumId: "eu-e-minha-casa",
    artistaId: "david-quinlan",
    artistaNome: "David Quinlan",
    albumTitulo: "Eu e a Minha Casa",
    titulo: "Sonda-me",
    duracao: "5:20",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 66,
    tomOriginal: "A",
    versao: "Estúdio",
    anoLancamento: 2005,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Lauriete
  {
    id: "lauriete-1",
    albumId: "alma-vencedora",
    artistaId: "lauriete",
    artistaNome: "Lauriete",
    albumTitulo: "Alma Vencedora",
    titulo: "Alma Vencedora",
    duracao: "5:25",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "Bb",
    versao: "Estúdio",
    anoLancamento: 2002,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "lauriete-2",
    albumId: "alma-vencedora",
    artistaId: "lauriete",
    artistaNome: "Lauriete",
    albumTitulo: "Alma Vencedora",
    titulo: "Não Vou Parar",
    duracao: "5:10",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 124,
    tomOriginal: "E",
    versao: "Estúdio",
    anoLancamento: 2002,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Rebanhão
  {
    id: "rebanhao-1",
    albumId: "vem-me-buscar",
    artistaId: "rebanhao",
    artistaNome: "Rebanhão",
    albumTitulo: "Vem Me Buscar",
    titulo: "Vem Me Buscar",
    duracao: "5:15",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 78,
    tomOriginal: "G",
    versao: "Estúdio",
    anoLancamento: 1998,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "rebanhao-2",
    albumId: "vem-me-buscar",
    artistaId: "rebanhao",
    artistaNome: "Rebanhão",
    albumTitulo: "Vem Me Buscar",
    titulo: "Não Há outro Igual",
    duracao: "5:30",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 82,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 1998,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Priscila Alcântara
  {
    id: "priscila-1",
    albumId: "eletroacustico",
    artistaId: "priscila-alcantara",
    artistaNome: "Priscila Alcântara",
    albumTitulo: "Eletroacústico",
    titulo: "Eletroacústico",
    duracao: "4:50",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 3,
    bpm: 80,
    tomOriginal: "C",
    versao: "Acústico",
    anoLancamento: 2021,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "priscila-2",
    albumId: "eletroacustico",
    artistaId: "priscila-alcantara",
    artistaNome: "Priscila Alcântara",
    albumTitulo: "Eletroacústico",
    titulo: "Me Redimiu",
    duracao: "5:20",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 74,
    tomOriginal: "G",
    versao: "Acústico",
    anoLancamento: 2021,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Thiago Brado
  {
    id: "brado-1",
    albumId: "serenata",
    artistaId: "thiago-brado",
    artistaNome: "Thiago Brado",
    albumTitulo: "Serenata",
    titulo: "Serenata",
    duracao: "5:10",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 68,
    tomOriginal: "F",
    versao: "Estúdio",
    anoLancamento: 2022,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "brado-2",
    albumId: "serenata",
    artistaId: "thiago-brado",
    artistaNome: "Thiago Brado",
    albumTitulo: "Serenata",
    titulo: "A Voz",
    duracao: "5:25",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "D",
    versao: "Estúdio",
    anoLancamento: 2022,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },

  // Novos álbuns - Renascer Praise
  {
    id: "renascer-1",
    albumId: "renascer-20",
    artistaId: "renascer-praise",
    artistaNome: "Renascer Praise",
    albumTitulo: "Renascer Praise 20",
    titulo: "Renascer Praise",
    duracao: "5:45",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 126,
    tomOriginal: "E",
    versao: "Ao Vivo",
    anoLancamento: 2008,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
  {
    id: "renascer-2",
    albumId: "renascer-20",
    artistaId: "renascer-praise",
    artistaNome: "Renascer Praise",
    albumTitulo: "Renascer Praise 20",
    titulo: "Digno é o Senhor",
    duracao: "5:30",
    preco: 49.9,
    previewDisponivel: true,
    paginas: 4,
    bpm: 72,
    tomOriginal: "A",
    versao: "Ao Vivo",
    anoLancamento: 2008,
    tonsDisponiveis: TONS_DISPONIVEIS,
  },
];